import { useLocaleStore } from "~/locale/locale.use-locale-store.hook"
import { numberFormatter } from "~/locale/locale.utils"

export function Volume({ volume }: { volume: number }) {
  const { state: locale } = useLocaleStore()
  const formatNumber = numberFormatter(locale)

  return formatNumber(volume)
}
